<template>
  <div style='width: 100%;'>

    <el-row :gutter="10">
            <el-col :span="12">
              <AddItem2List id='more1' :title="more.title1" :type="more.type1" :custId="custId" @updateSelected="syncSelectParent"/>
            </el-col>
            <el-col :span="12">
              <AddItem2List id='more2' :title="more.title2" :type="more.type2" :custId="custId" @updateSelected="syncSelectParent"/>
            </el-col>
          </el-row>   
  </div>
</template>

<script>
import AddItem2List from './AddItem2List'
export default {
  name: 'productInfo',
  props: {    
    custId: {
        type: String
    }   
  },
  data() {   
    return {     
      more:{
        title1: this.$i18n.t('field.innocareModel'),
        title2: this.$i18n.t('field.odmModel'),
        type1:'MORE_INNOCARE',
        type2:'MORE_OEM',
        selectedLlist1:[],
        selectedLlist2:[]           
      },
    };
  },  
  components: {
    AddItem2List
  }, 
  mounted() {
    
  },
  methods: {
    syncSelectParent(value, type){
      if(type == 'MORE_INNOCARE'){
        this.more.selectedLlist1 = value;
      }else if(type == 'MORE_OEM'){
        this.more.selectedLlist2 = value;   
      }
      this.$emit('update', this.more);       
    }
  }
};
</script>
